import WebworkerPromise from 'webworker-promise';
import {
  startWorker, Workers,
} from '~/_shared/utils/worker/startWorker';
import type { ExportReportTemplateSelectorArea } from '~/exportReport/templateSelector/exportReportTemplateSelector.constants';
import type { ExportReportAreaQuery } from '~/exportReport/validation/exportReportAreas.worker.helpers';

export const getExportReportAreas = async (query: ExportReportAreaQuery): Promise<ReadonlyArray<ExportReportTemplateSelectorArea>> => {
  const worker = new WebworkerPromise(startWorker(Workers.GetExportReportAreas));

  return worker.postMessage(query)
    .finally(() => {
      worker.terminate();
    });
};
